import { ArrowRight } from "lucide-react";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";

export default function AssessmentContact({ onSubmit }) {
  return (
    <div data-testid="assessment-contact" className="max-w-md mx-auto">
      <div className="text-center mb-8">
        <h3 className="text-white font-bold text-2xl mb-2" style={{ fontFamily: "Outfit" }}>Almost there.</h3>
        <p className="text-[#c0cfe0] text-sm">Enter your details to see your full Business Intelligence Score.</p>
      </div>
      <form onSubmit={onSubmit} className="space-y-4">
        <Input name="company" placeholder="Company name" required className="bg-white/5 border-white/10 text-white placeholder:text-[#c0cfe0]/40 rounded-md h-11" />
        <Input name="name" placeholder="Your name" required className="bg-white/5 border-white/10 text-white placeholder:text-[#c0cfe0]/40 rounded-md h-11" />
        <Input name="phone" type="tel" placeholder="Phone" required className="bg-white/5 border-white/10 text-white placeholder:text-[#c0cfe0]/40 rounded-md h-11" />
        <Input name="email" type="email" placeholder="Email" required className="bg-white/5 border-white/10 text-white placeholder:text-[#c0cfe0]/40 rounded-md h-11" />
        <textarea name="situation" placeholder="Tell us a little about your current situation or challenges..." rows={3} className="w-full bg-white/5 border border-white/10 text-white placeholder:text-[#c0cfe0]/40 rounded-md px-3 py-2 text-sm resize-none focus:outline-none focus:border-[#0077B3]" />
        <div>
          <p className="text-[#c0cfe0] text-xs mb-2">Preferred contact method:</p>
          <div className="flex gap-3">
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="radio" name="contact_preference" value="call" defaultChecked className="accent-[#0077B3]" />
              <span className="text-white text-sm">Call me</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="radio" name="contact_preference" value="email" className="accent-[#0077B3]" />
              <span className="text-white text-sm">Email me</span>
            </label>
          </div>
        </div>
        <Button type="submit" className="w-full bg-[#0077B3] hover:bg-[#005f8f] text-white rounded-md font-semibold h-12">
          Show My Results <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
        <p className="text-[#c0cfe0]/30 text-xs text-center">No spam. No sales pressure. Your data stays private.</p>
      </form>
    </div>
  );
}
